import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { notify } from 'app/store/common-effects/notifier.effects';
import { removeWebhook } from 'app/store/root/webhooks/webhooks.actions';
import { events, webhooks } from 'app/store/root/webhooks/webhooks.selectors';
import { WebhookOutput } from 'core/http/root';
import { selectFirst } from 'core/utils/rx-common';
import { KeyValue } from 'shared/common/types';
import { EagerSource } from 'shared/modules/table/table-utils/table-interfaces';

@Component({
  selector: 'app-webhooks',
  templateUrl: './webhooks.component.html',
  styleUrls: ['./webhooks.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class WebhooksComponent implements OnInit {
  private _events = new Array<KeyValue>();
  private _loading = false;
  readonly columns: string[] = [
    'url',
    'event',
    'retries',
    'actions',
  ];

  get loading(): boolean {
    return this._loading;
  }

  set loading(value: boolean) {
    this._loading = value;
  }

  get events(): KeyValue[] {
    return this._events;
  }

  constructor(private store$: Store) { }

  dataSource: EagerSource<WebhookOutput> = () => this.store$.select(webhooks);

  ngOnInit(): void {
    this.store$.pipe(selectFirst(events))
      .subscribe(data => this._events = data);
  }

  getEventName(eventValue: string): string {
    const event = this.events.find(e => e.key === eventValue);
    return event && event.value;
  }

  removeWebhook(id: string): void {
    this.store$.dispatch(removeWebhook({ id }));
  }

  copyUrl(event: any): void {
    event.target.select();
    document.execCommand('copy');
    this.store$.dispatch(notify({ message: 'NOTIFICATIONS.url_copied' }));
  }
}
